import {
    mapState,
    mapMutations
  } from 'vuex'
import api from '../service/services.js'
import moment from 'moment'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  data () {
    return {
      datestart: moment(new Date()).format('YYYY-MM-DD'),
      dateend: moment(new Date()).format('YYYY-MM-DD'),
      isLoading: false,
      search: '',
      screenHeight: window.innerHeight - 225,
      data_search: []
    }
  },
  computed: {
    ...mapState(['user', 'url']),
    ...mapMutations(['checkLogin'])
  },
  components: {
    Loading
  },
  methods: {
    getData () {
      var obj = {
        search: this.search
      }
      this.isLoading = true
      api.searchEmail(this.url, obj, result => {
        if (result.status === 1) {
          this.data_search = result.data
        } else {
          swal.fire(
            'Error 500',
            'การดึงข้อมูลอีเมลมีปัญหา!! ' + result.data,
            'error'
          )
        }
        this.isLoading = false
      }, error => {
        this.isLoading = false
        alert(JSON.stringify(error))
      })
    },
    dateFormat (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  mounted () {
    try {
      this.checkLogin()
    } catch (e) {
      // location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/email.js